module.exports = "<!-- <layout-header [headers]=\"headers\"></layout-header> -->\n\n<router-outlet></router-outlet>\n\n<!-- <layout-footer [footers]=\"footers\"></layout-footer> -->\n"


//////////////////
// WEBPACK FOOTER
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main